import { Component, OnInit,ViewChild,ElementRef ,Input , Output,EventEmitter} from '@angular/core';
import { GfichierService } from '../../service/gfichier.service';


@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss'],
})
export class DateComponent implements OnInit {

 
  @Input() content: string;
  @Input() id: number;
  @Input() edit: number;
  @Input() posi: number;

  @Output() eventchild = new EventEmitter<string>();
 

  @ViewChild('divdate', {static: true}) divdate : ElementRef;
  

  ladate = "1980";
  texte: string = "test";
  constructor(public gfichier: GfichierService) { }

  ngOnInit() { }

  ngOnChanges() {
    //if (edit==0)
    //    this.texte =
      this.ladate = this.content;
      if (this.edit<2)
         this.texte = this.gfichier.getValue2(this.id, "desc");
      else 
         this.texte = this.gfichier.getValue(this.posi,this.id, "desc");
      
  }

  


  OnChange($event: string) {

    this.gfichier.setValue($event,this.id,"date");

    this.eventchild.emit("miseajourtexte");
   
    //alert(this.texte);
    

  }

  OnChange2($event:string){

    //alert("hjhj");

    this.gfichier.setValue($event,this.id,"desc");

     this.eventchild.emit("miseajourtexte");


  }


}
